import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Silence non-critical console output in production builds
if (process.env.NODE_ENV === 'production') {
  ['log', 'debug', 'info', 'trace'].forEach((m) => {
    try { console[m] = () => {}; } catch {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
